import { useDevise } from '../contexts/DeviseContext'

const Money = ({ amount }) => {
    const { format } = useDevise()
    return <>{format(amount)}</>
}

export default Money
